import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
const PracticalLine = (t0) => {
    const $ = _c(20);
    const { icon, label, content, unavailable, labelClassName: t1 } = t0;
    const labelClassName = t1 === undefined ? "" : t1;
    const translate = useTranslate();
    let t2;
    if ($[0] !== label) {
        t2 = label ? capitalize(label) : null;
        $[0] = label;
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const capitalizedLabel = t2;
    let t3;
    if ($[2] !== content) {
        t3 = typeof content === "string" ? capitalize(content) : content;
        $[2] = content;
        $[3] = t3;
    }
    else {
        t3 = $[3];
    }
    const capitalizedContent = t3;
    const computedLabelClassName = `${labelClassName} practical-line-label align-baseline text-gray-400 mr-1`;
    let t4;
    if ($[4] !== icon) {
        t4 = icon &&
            <span className="practical-line-icon inline-block align-text-top mr-3 text-gray-400">
      {icon}
    </span>;
        $[4] = icon;
        $[5] = t4;
    }
    else {
        t4 = $[5];
    }
    let t5;
    if ($[6] !== capitalizedLabel || $[7] !== computedLabelClassName || $[8] !== label) {
        t5 = label && <span className={computedLabelClassName}>{capitalizedLabel} :</span>;
        $[6] = capitalizedLabel;
        $[7] = computedLabelClassName;
        $[8] = label;
        $[9] = t5;
    }
    else {
        t5 = $[9];
    }
    let t6;
    if ($[10] !== capitalizedContent || $[11] !== translate || $[12] !== unavailable) {
        t6 = unavailable ? <>

      <del className="practical-line-content-unavailable">{capitalizedContent}</del>
      <span className="unavailable invisible">{translate("messages.unavailable")}</span></> :
            <span className="practical-line-content align-baseline">{capitalizedContent}</span>;
        $[10] = capitalizedContent;
        $[11] = translate;
        $[12] = unavailable;
        $[13] = t6;
    }
    else {
        t6 = $[13];
    }
    let t7;
    if ($[14] !== t5 || $[15] !== t6) {
        t7 = <div className="mt-2 inline">{t5}{t6}
    </div>;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    }
    else {
        t7 = $[16];
    }
    let t8;
    if ($[17] !== t4 || $[18] !== t7) {
        t8 = <div className="pratical-line inline font-semibold leading-6 text-gray-500 mb-3">{t4}{t7}
    </div>;
        $[17] = t4;
        $[18] = t7;
        $[19] = t8;
    }
    else {
        t8 = $[19];
    }
    return t8;
};
export default PracticalLine;
